<template>
  <div class="deviceLibraryPage">
    <div class="big_box">
      <!-- query -->
      <el-card class="box-card1">
        <el-form :inline="true" :model="search_form" class="demo-form-inline">
          <el-form-item label="项目:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-select id="pro" v-model="search_form.cloud_pro_id" placeholder="请选择项目" @change="handle_change_cloud_pro" style="" clearable filterable>
              <el-option v-for="item in cloud_pro_option" :key="item.id" :label="item.cloudName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询字段:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-input v-model="search_form.search_all" placeholder="输入任意字段模糊查询" clearable @keyup.enter.native="handler_search"></el-input>
          </el-form-item>
          <!-- <el-form-item label="设备名称:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-input id="deviceTypeDesc" v-model="search_form.search_type_desc" placeholder="请输入设备类型" clearable @keyup.enter.native="handler_search"></el-input>
          </el-form-item>
          <el-form-item label="设备类型:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-input id="deviceType" v-model="search_form.search_device_type" placeholder="请输入设备类型" clearable @keyup.enter.native="handler_search"></el-input>
          </el-form-item>
          <el-form-item label="设备category:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-input id="category" v-model="search_form.search_category" placeholder="请输入设备category" @keyup.enter.native="handler_search" clearable></el-input>
          </el-form-item>
          <el-form-item label="设备中文名:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-input id="modelDeviceNameCn" v-model="search_form.search_device_name" placeholder="请输入设备中文名" @keyup.enter.native="handler_search" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="协议类型:" style="margin-bottom: 5px; margin-top: 5px;">
            <el-select id="protocolType" v-model="search_form.search_protocol_type" placeholder="请选择协议类型"  style="" clearable filterable @change="handle_change_protocol_type">
              <el-option v-for="item in protocolType_option" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handler_search" style="margin-bottom: 5px; margin-top: 5px;">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card1">
        <div slot="header" class="table_title">
          <span>设备库</span>
          <div>
            <el-button type="" @click="handle_batch_publish" :disabled="this.multipleSelection.length == 0" >批量发布</el-button>
            <el-button type="primary" @click="show_add_dialog">新增model_info</el-button>
          </div>
        </div>
        <!-- table -->
        <el-table :data="table_data" @selection-change="handleSelectionChange" border style="width:100%" :header-cell-style="headClass" :cell-style="rowClass" class="table">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="typeDesc" label="设备类型名称" min-width="150"> </el-table-column>
          <el-table-column prop="deviceType" label="设备类型" min-width="120"> </el-table-column>
          <el-table-column prop="category" label="设备category" min-width="150"> </el-table-column>
          <el-table-column prop="modelDeviceNameCn" label="设备中文名" min-width="150"> </el-table-column>
          <el-table-column prop="protocolType" label="协议类型" min-width="120">
            <template slot-scope="{row}">
              {{ row.protocolType === 1 ? '有线' : row.protocolType === 2 ? '无线' : row.protocolType == 3 ? '蓝牙' : row.protocolType == 4 ? 'RS485' : row.protocolType == 6 ? 'PLC' : '未知' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width='330px'>
            <template slot-scope="{row}">
              <el-button type="text" @click="handel_copy_mode_info_detail(row)" style="color:#3377FF">复 制</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" style="color:#3377FF" @click="show_edit_dialog(row)">修 改</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" style="color:#3377FF" @click="handel_publish(row)">发 布</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" style="color:#3377FF" @click="show_modelinfo_version_list_dialog(row)">版本列表</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" style="color:#FB3F4E" class="del_btn" @click="handel_del(row.id)">删 除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current_page"
            :page-sizes="pageSizeList"
            :page-size="page_size"
            layout="prev, pager, next,sizes, total, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
      <!-- dialog ==> 添加mode-info表单 -->
      <el-dialog :title="dialog_title" :visible.sync="addDialogVisible" width="40%" center class="dialog" :close-on-click-modal="false">
        <el-card class="box-card">
          <el-form ref="form" :model="form" label-width="140px" label-position="right" :rules="validateRules">
            <!--  :inline="true" -->
            <el-form-item label="设备类型：" prop="deviceType">
              <el-input v-model="form.deviceType" placeholder="请输入设备类型" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="设备类型名称：" prop="typeDesc">
              <el-input v-model="form.typeDesc" placeholder="请输入设备类型名称" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="是否展示：" prop="isShow">
              <el-radio-group v-model="form.isShow" :disabled="this.flag === 3">
                <el-radio :label="true">展示</el-radio>
                <el-radio :label="false">不展示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="设备模型中文名：" prop="modelDeviceNameCn">
              <el-input v-model="form.modelDeviceNameCn" placeholder="请输入设备模型中文" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="设备模型英文名：" prop="modelDeviceNameEn">
              <el-input v-model="form.modelDeviceNameEn" placeholder="请输入设备模型英文" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="是否是复合设备：" prop="isCompositeDev">
              <el-radio-group v-model="form.isCompositeDev" :disabled="this.flag === 3">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">不是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="协议类型：" prop="protocolType">
              <el-select id="pro" v-model="form.protocolType"  style="width:100%" clearable filterable placeholder="请选择协议类型" :disabled="this.flag === 3" @change="change_protocolType">
                <el-option v-for="item in protocolType_option" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否有设备配置：" prop="haveConfig">
              <el-radio-group v-model="form.haveConfig" :disabled="this.flag === 3">
                <el-radio :label="true">有</el-radio>
                <el-radio :label="false">没有</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否有设备事件：" prop="haveEvent">
              <el-radio-group v-model="form.haveEvent" :disabled="this.flag === 3">
                <el-radio :label="true">有</el-radio>
                <el-radio :label="false">没有</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否有设备控制：" prop="haveControl">
              <el-radio-group v-model="form.haveControl" :disabled="this.flag === 3">
                <el-radio :label="true">有</el-radio>
                <el-radio :label="false">没有</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否是网关：" prop="isGateway">
              <el-radio-group v-model="form.isGateway" :disabled="this.flag === 3">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">不是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否是端口设备：" prop="isPort">
              <el-radio-group v-model="form.isPort" :disabled="this.flag === 3">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">不是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否需要设备列表：" prop="isNeedDevice">
              <el-radio-group v-model="form.isNeedDevice" :disabled="this.flag === 3">
                <el-radio :label="true">需要</el-radio>
                <el-radio :label="false">不需要</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否是路由设备：" prop="isRoute">
              <el-radio-group v-model="form.isRoute" :disabled="this.flag === 3">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">不是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否是遥控设备：" prop="isRemote">
              <el-radio-group v-model="form.isRemote" :disabled="this.flag === 3">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">不是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="端口列表：" prop="portList">
              <el-input v-model="form.portList" placeholder="请输入端口列表" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="配置列表：" prop="configList">
              <el-input v-model="form.configList" placeholder="请输入配置列表" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="控制列表：" prop="controlList">
              <el-input v-model="form.controlList" placeholder="请输入控制列表" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="事件列表：" prop="eventList">
              <el-input v-model="form.eventList" placeholder="请输入事件列表" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="种类(category)：" prop="category">
              <el-input v-model="form.category" placeholder="请输入设备种类" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="项目号：" prop="cloudId">
              <el-select id="pro" v-model="form.cloudId"  style="width:100%" clearable filterable placeholder="请选择项目号" :disabled="this.flag === 3">
                <el-option v-for="item in cloud_pro_option" :key="item.id" :label="item.cloudName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态域：" prop="statusProperties">
              <el-input v-model="form.statusProperties" placeholder="请输入状态域" type="textarea" :autosize="{ minRows: 6, maxRows: 10}" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="控制域：" prop="commandProperties">
              <el-input v-model="form.commandProperties" placeholder="请输入控制域" type="textarea" :autosize="{ minRows: 6, maxRows: 10}" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <el-input v-model="form.remark" placeholder="请输入备注" :disabled="this.flag === 3"></el-input>
            </el-form-item>
            <el-form-item style="display:flex;justify-content:flex-end;width:100%">
              <el-button type="primary" @click="addDialogVisible = false" class="btn1" v-show="this.flag === 3">关闭</el-button>
              <el-button type="info" @click="addDialogVisible = false" class="btn1" v-show="this.flag !== 3">取消</el-button>
              <el-button type="primary" @click="submit_mode_info('form')" class="btn2" v-show="this.flag !== 3">确定</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-dialog>
      <!-- dialog ==> model-info版本列表 -->
      <el-dialog title="model_info版本列表" :visible.sync="versionListDialogVisible" width="70%" center class="dialog" :close-on-click-modal="false">
        <el-card class="box-card">
          <el-table :data="modelinfo_version_table_data" border style="width:100%" :header-cell-style="headClass" :cell-style="rowClass" class="table">
            <el-table-column prop="modelDeviceNameCn" label="模型设备中文名" min-width="150"> </el-table-column>
            <el-table-column prop="deviceType" label="设备类型" min-width="120"> </el-table-column>
            <el-table-column prop="version" label="版本号" min-width="120"> </el-table-column>
            <!-- <el-table-column prop="versionRemark" label="版本备注" min-width="180"> </el-table-column> -->
            <el-table-column prop="createTime" label="创建时间" min-width="160"> </el-table-column>
            <el-table-column prop="createUserName" label="操作人员" min-width="120"> </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="180"> </el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="{row}">
                <el-button type="text" @click="handel_look_mode_info_version_detail(row)" style="color:#3377FF">详 情</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" style="color:#FB3F4E" @click="handel_rollback(row)">回 滚</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              background
              @size-change="handleDetailSizeChange"
              @current-change="handleDetailCurrentChange"
              :current-page="detail_current_page"
              :page-sizes="detail_pageSizeList"
              :page-size="detail_page_size"
              layout="prev, pager, next,sizes, total, jumper"
              :total="detail_total">
            </el-pagination>
          </div>
        </el-card>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { model_info_list, add_model_info, edit_model_info, del_model_info, model_info_detail, publish, rollback, model_info_version_list, model_info_version_detail} from "@/api/device_lib.js"
import { cloudSelectInfo } from '@/api'
export default {
  data() {
    return {
      deviceModelInfoId:"",

      search_form: {
        cloud_pro_id:"",
        search_type_desc: "",
        search_device_type:"",
        search_device_name:"",
        search_protocol_type:"",
        search_category:"",
        search_all:''
      },

      cloud_pro_option: [],
      protocolType_option:[
        { value: 1, label: '有线' },
        { value: 2, label: '无线' },
        { value: 3, label: '蓝牙' },
        { value: 4, label: 'RS485' },
        { value: 6, label: 'PLC' },
      ],

      addDialogVisible:false,//添加modelinfo dialog可见
      versionListDialogVisible: false,//modeinfo 版本list可见
      dialog_title:"",
      flag:'',//1:添加  2.修改  3.详情

      table_data:null,
      multipleSelection:[],//多选
      modelinfo_version_table_data:null,

      form: {
        deviceType:"",
        typeDesc: '',
        isShow: "",
        modelDeviceNameCn:'',
        modelDeviceNameEn:"",
        haveConfig:"",
        haveEvent:"",
        haveControl:"",
        isGateway:"",
        isCompositeDev:"",
        isPort:"",
        isNeedDevice:"",
        isRoute:"",
        isRemote:"",
        portList:"",
        configList:"",
        controlList:"",
        eventList:"",
        category:"",
        statusProperties:"",
        commandProperties:"",
        cloudId:"",
        protocolType:"",
        remark:""
      },

      validateRules:{
        deviceType:[{ required: true, message: "设备类型不能为空", trigger: "blur"}],
        typeDesc: [{ required: true, message: "设备类型名称不能为空", trigger: "blur"}],
        isShow: [{ required: true, message: "请选择是否展示", trigger: "blur"}],
        haveConfig: [{ required: true, message: "请选择是否有设备配置", trigger: "blur"}],
        haveEvent: [{ required: true, message: "请选择是否有设备事件", trigger: "blur"}],
        haveControl: [{ required: true, message: "请选择是否有设备控制", trigger: "blur"}],
        isGateway: [{ required: true, message: "请选择是否是网关", trigger: "blur"}],
        isCompositeDev: [{ required: true, message: "请选择是否是复合设备", trigger: "blur"}],
        isPort: [{ required: true, message: "请选择是否是端口设备", trigger: "blur"}],
        isNeedDevice: [{ required: true, message: "请选择是否需要设备列表", trigger: "blur"}],
        isRoute: [{ required: true, message: "请选择是否是路由设备", trigger: "blur"}],
        isRemote: [{ required: true, message: "请选择是否是遥控设备", trigger: "blur"}],
        category: [{ required: true, message: "category不能为空", trigger: "blur"}],
        cloudId: [{ required: true, message: "项目不能为空", trigger: "blur"}],
        protocolType: [{ required: true, message: "协议类型不能为空", trigger: "blur"}],
        remark: [{ required: true, message: "备注不能为空", trigger: "blur"}],
      },

      pageSizeList:[10,50,100,500,1000],
      current_page:1,
      page_size:10,
      total:null,
      detail_pageSizeList:[10,20,30,40],
      detail_current_page:1,
      detail_page_size:10,
      detail_total:null,
    }
  },
  created(){
    this.get_cloud_pro_list()
  },
  methods: {
    handel_del(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = { id: id }
        del_model_info(data).then(({ data }) => {
          let {code} = data
          if (code === 0) {
            this.$message.success('删除成功')
            this.get_model_info_list()
          }
        })
      }).catch(() => {
        this.$message.warning('取消删除')
      })
    },
    get_model_info_list(pageNum,pageSize){
      let data = {
        cloudId: this.search_form.cloud_pro_id,
        page: { pageNum: pageNum || this.current_page, pageSize: pageSize || this.page_size},
        typeDesc: this.search_form.search_type_desc,
        modelDeviceNameCn: this.search_form.search_device_name,
        protocolType: this.search_form.search_protocol_type,
        deviceType: this.search_form.search_device_type,
        category: this.search_form.search_category,
        searchAll: this.search_form.search_all,
      }
      model_info_list(data).then( ({data}) => {
        let { code, data:result, count } = data
        if(code === 0){
          console.log('mode_info列表',result);
          this.total = 0
          this.table_data = []
          this.total = count
          this.table_data = result
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    submit_mode_info(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          if(this.flag === 1){
            add_model_info(this.form).then(res=>{
              if(res.data.code == 0){
                this.$message.success("添加成功")
                this.addDialogVisible = false
                this.get_model_info_list(1,10)
              }else{
                this.$message.error(`${res.data.message}`)
              }
            })
          }else if(this.flag === 2){
            edit_model_info(this.form).then(res=>{
              if(res.data.code == 0){
                this.$message.success("修改成功")
                this.addDialogVisible = false
                this.get_model_info_list()
              }else{
                this.$message.error(`${res.data.message}`)
              }
            })
          }
        }else{
          this.$message.error("表单验证不通过")
        }
      })
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handel_publish(row){
      let arr = [row.id]
      let formData = new FormData();
      formData.append('ids', arr);
      this.publish_model_info(formData)
    },
    handle_batch_publish(){
      let formData = new FormData();
      let arr = this.multipleSelection.map(item => item.id)
      formData.append('ids', arr);
      this.publish_model_info(formData)
    },
    publish_model_info(formData){
      publish(formData).then( res => {
        if(res.data.code == 0){
          this.$message.success("发布成功")
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    handel_rollback(row){
      let data = { id: row.id }
      rollback(data).then( res => {
        if(res.data.code == 0){
          this.$message.success("回滚成功")
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    handel_copy_mode_info_detail(row){
      console.log('row',row)
      this.flag = 1
      this.dialog_title = '复制'
      if (this.$refs['form'] !== undefined) {
        this.$refs['form'].clearValidate();
      }
      let data = {id: row.id}
      model_info_detail(data).then(res=>{
        console.log('modeinfo 详情',res.data.data);
        if(res.data.code == 0){
          this.form = res.data.data
          this.form.typeDesc = ''
          this.form.deviceType = ''
          this.addDialogVisible = true
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    handel_look_mode_info_version_detail(row){
      this.flag = 3
      this.dialog_title = '版本详情'
      let data = { id: row.id }
      model_info_version_detail(data).then( res => {
        if(res.data.code == 0){
          console.log('modeinfo版本详情',res.data.data);
          this.form = res.data.data
          this.addDialogVisible = true
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    show_modelinfo_version_list_dialog(row){
      this.deviceModelInfoId = row.id
      this.get_model_info_version_list()
    },
    get_model_info_version_list(){
      let data = { 
        deviceModelInfoId: this.deviceModelInfoId,
        page: { pageNum: this.detail_current_page, pageSize: this.detail_page_size }
      }
      model_info_version_list(data).then(res=>{
        if(res.data.code == 0){
          this.detail_total = res.data.count
          console.log('modeinfo 版本 list数据',res.data.data);
          this.modelinfo_version_table_data = res.data.data
          this.versionListDialogVisible = true
        }else{
          this.$message.error(`${res.data.message}`)
        }
      })
    },
    show_edit_dialog(row){
      this.flag = 2
      this.addDialogVisible = true
      this.dialog_title = '修改'
      if (this.$refs['form'] !== undefined) {
        this.$refs['form'].clearValidate();
      }
      let data = {id: row.id}
      model_info_detail(data).then(res=>{
        if(res.data.code == 0){
          console.log('modeinfo 详情',res.data.data);
          this.$nextTick(()=>{
            this.form = res.data.data
            // this.form = row
          }) 
        }else{
          this.$message.error(`${res.data.message}`)
        } 
      })
    },
    show_add_dialog(){
      this.flag = 1
      this.addDialogVisible = true
      this.dialog_title = '新增'
      console.log("this.$refs['form']",this.$refs['form'])
      if (this.$refs['form'] !== undefined) {
        this.$refs['form'].resetFields();
        this.$refs['form'].clearValidate();
      }
    },
    //获得云项目list
    get_cloud_pro_list() {
      cloudSelectInfo().then((res) => {
        let data = res.data.data
        this.cloud_pro_option = data;
        this.search_form.cloud_pro_id = data[0].id   
        this.get_model_info_list(1,10)
      });
    },
    //改变云项目
    handle_change_cloud_pro(event){
      console.log("handle_change_cloud_pro",event)
      if(event){
        this.search_form.cloud_pro_id = event
      }else{
        this.search_form.cloud_pro_id = 0
      }
      this.get_model_info_list(1,10)
    },
    handle_change_protocol_type(e){
      console.log('handle_change_protocol_type',e)
      this.search_form.search_protocol_type = e
      this.get_model_info_list(1, 10)
    },
    change_protocolType(e){
      console.log('change_protocolType',e)
    },
    handler_search(){
      this.get_model_info_list(1, 10)
    },
    //分页
    handleDetailSizeChange(val){
      this.detail_page_size = val
      this.get_model_info_version_list()
    },
    handleDetailCurrentChange(val){
      this.detail_current_page = val
      this.get_model_info_version_list()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.get_model_info_list()
    },
    handleCurrentChange(val) {
      this.current_page = val
      this.get_model_info_list()
    },
    //表格样式
    headClass() {
      return 'text-align: center;background: #F2F3F7;font-size: 14px;color: #000000;opacity: 0.85;'
    },
    rowClass() {
      return 'text-align: center;'
    }
  },
}
</script>

<style lang='scss' scoped>
.deviceLibraryPage{
  background: #F0F3FA;
  // min-height:calc(100vh - 50px);
  font-family: PingFang SC;
  height: 92%;
  
  .big_box{
    display: flex;
    flex-direction: column;
    align-items: center;
    .box-card1 {
      width: 98%;
      margin-top: 20px;
      border: 1px solid #DBDDE3;
      border-radius: 5px;
      .table_title{
        line-height: 38px;
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        display: flex;
        justify-content: space-between;
        .btn-4{
          width: 120px;
          height: 40px;
          background: #455AF7;
          border-radius: 5px;
          float: right; 
          padding: 3px 0 ; 
          margin-left:20px
        }
      }
      .table{
        &::v-deep .cell{
          color: #000000;
          opacity: 0.8;
        }
      }
      &::v-deep .el-card__header{
        padding: 14px 20px;
      }
      // &::v-deep .el-pagination{
      //   padding: 16px 0;
      //   text-align: right;
      // }
      // &::v-deep .el-pagination .active{
      //   background-color:#3377FF
      // }
    }
    .dialog{
      &::v-deep label{
        font-weight: 500;
      }
      
      &::v-deep .el-dialog__header{
        box-shadow: 0px 1px 9px 0px rgba(0, 21, 41, 0.09)  !important;
      }
      // &::v-deep .el-dialog__body{
      //   padding: 10px !important;
      //   background: red !important;
      // }
      &::v-deep .el-form-item{
        width: 32%;
      }
      &::v-deep .el-card{
        margin: 20px;
      }
      &::v-deep .area-select.large{
        width: 100%;
        line-height: 20px;
        height: 40px;
      }
      &::v-deep .el-select{
        width: 100%;
      }
      .textarea{
        display:flex;
        width:100%;
        &::v-deep .el-form-item__content{
          width: 70%;
        }
      }
    }
  }
  .el-button--primary{
    background: #455AF7!important;
    border-color: #455AF7!important;
  }
  .el-button--text{
    color: #455AF7!important;
  }
  .del_btn{
    color: red!important;
  }
}
.dialog ::v-deep .el-form--label-left .el-form-item__label{
  text-align: right!important;
}
.dialog .el-form--inline .el-form-item{
    display: block!important;
  }
  .dialog .el-form--inline .el-form-item__content{
    // display: block!important;
    width: calc(100% - 200px)!important;
  }
  // .dialog .el-form--inline:last-child .el-form-item__content:last-child{
  //   width: 100%!important;
  //   display: flex;
  //   justify-content: flex-end;
  //   margin-right: 70px;
  // }
.dialog ::v-deep .el-dialog__body{
  padding: 10px !important;
  background: #F2F3F7 !important;
}
.dialog .el-form-item:last-child ::v-deep .el-form-item__content:last-child{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 70px;
}
.pagination{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 15px 0;
  box-sizing: border-box;
}
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
.label{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/equipmentLibrary/device_library.vue